import ContractService from '@services/contract.service';

export default {
    data() {
        return {
            pdf_loading: false
        };
    },
    methods: {
        pdf(contractId, contractNum, lang) {
            this.pdf_loading = !this.pdf_loading;
            ContractService.pdf(contractId, contractNum, lang).then(() => {
                this.pdf_loading = !this.pdf_loading;
            }).catch(e => {
                this.pdf_loading = !this.pdf_loading;
            });
        }
    }
};
